const __WEBPACK_NAMESPACE_OBJECT__ = flarum.extensions['fof-terms'];